import React, { useEffect, useRef, useState } from 'react'
import zephyr from "../../../../assets/images/Zephyr.png";
import cloudimg from "../../../../assets/images/cloudimg.png";
import mobilebrowser from "../../../../assets/images/mobilebrowser.png";
import mobilecloud from "../../../../assets/images/mobilecloud.png";
import browsersimple from '../../../../assets/images/browsersimple.png'
import aiagent from '../../../../assets/images/aiagent.png'
import styled from "@emotion/styled";
import { Modal } from '@mui/material';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: clip;
  padding-top: 16px;
  --zephyr-x: 0px;
  --zephyr-y: 0px;
  --zephyr-rotate: 0deg;
  --zephyr-rotate-x: 0deg;
  --zephyr-rotate-y: 0deg;
  --cloud-x: 0px;
  --cloud-y: 0px;

  @media (max-width: 1600px) and (min-width: 1025px) {
    height: 100vh;
    min-height: 900px;
  }
  @media (max-width: 1024px) {
    height: 100vh;
    min-height: 600px;
  }
  @media (max-width: 768px) {
    height: 85vw;
    min-height: 420px;
    max-height: 580px;
    padding-top: 24px;
  }
  @media (max-width: 480px) {
    height: 100vh;
    min-height: 360px;
    /* max-height: 480px; */
    padding-top: 20px;
  }
  @media (max-width: 360px) {
    height: 95vw;
    min-height: 320px;
  }
`;

const ZephyrImage = styled.img`
  position: absolute;
  top: 40px;
  left: 50%;
  width: 100%;
  max-width: 1900px;
  transform: perspective(1200px) translate3d(calc(-50% + var(--zephyr-x)), var(--zephyr-y), 0) rotateX(var(--zephyr-rotate-x)) rotateY(var(--zephyr-rotate-y));
  z-index: 1;
  user-select: none;
  pointer-events: none;
  will-change: transform;
  animation: zephyrReveal 1.25s cubic-bezier(0.16, 1, 0.3, 1) both;

  @keyframes zephyrReveal {
    0% {
      opacity: 0;
      filter: blur(18px);
      transform: perspective(1200px) translate3d(-50%, 80px, -180px) scale(0.78) rotateX(14deg);
    }

    62% {
      opacity: 1;
      filter: blur(4px);
      transform: perspective(1200px) translate3d(-50%, -10px, 0) scale(1.035) rotateX(-2deg);
    }

    100% {
      opacity: 1;
      filter: blur(0);
      transform: perspective(1200px) translate3d(calc(-50% + var(--zephyr-x)), var(--zephyr-y), 0) rotateX(var(--zephyr-rotate-x)) rotateY(var(--zephyr-rotate-y));
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @media (max-width: 1024px) {
    top: 60px;
    width: 100%;
  }
  @media (max-width: 768px) {
    top: 50px;
    width: 100%;
  }
  @media (max-width: 480px) {
    top: 40px;
    width: 100%;
    max-width: 470px;
  }
  @media (max-width: 360px) {
    top: 30px;
    width: 100%;
    max-width: 400px;
  }
`;

const BlurLayer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12%;
  height: 55%;
  z-index: 2;
  pointer-events: none;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1920' height='625' viewBox='0 0 1920 625' fill='none'%3E%3CforeignObject x='-31.8' y='-31.8' width='1983.6' height='688.197'%3E%3Cdiv xmlns='http://www.w3.org/1999/xhtml' style='backdrop-filter:blur(15.9px);clip-path:url(%23bgblur_0_1_14_clip_path);height:100%25;width:100%25'%3E%3C/div%3E%3C/foreignObject%3E%3Cg filter='url(%23filter0_n_1_14)' data-figma-bg-blur-radius='31.8'%3E%3Crect width='1920' height='624.597' fill='url(%23paint0_linear_1_14)' fill-opacity='0.5'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_n_1_14' x='-31.8' y='-31.8' width='1983.6' height='688.197' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2 2' stitchTiles='stitch' numOctaves='3' result='noise' seed='5857'/%3E%3CfeColorMatrix in='noise' type='luminanceToAlpha' result='alphaNoise'/%3E%3CfeComponentTransfer in='alphaNoise' result='coloredNoise1'%3E%3CfeFuncA type='discrete' tableValues='1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 '/%3E%3C/feComponentTransfer%3E%3CfeComposite operator='in' in2='shape' in='coloredNoise1' result='noise1Clipped'/%3E%3CfeFlood flood-color='rgba(255, 255, 255, 0.25)' result='color1Flood'/%3E%3CfeComposite operator='in' in2='noise1Clipped' in='color1Flood' result='color1'/%3E%3CfeMerge result='effect1_noise_1_14'%3E%3CfeMergeNode in='shape'/%3E%3CfeMergeNode in='color1'/%3E%3C/feMerge%3E%3C/filter%3E%3CclipPath id='bgblur_0_1_14_clip_path' transform='translate(31.8 31.8)'%3E%3Crect width='1920' height='624.597'/%3E%3C/clipPath%3E%3ClinearGradient id='paint0_linear_1_14' x1='960' y1='0' x2='960' y2='624.597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D9D8D8'/%3E%3Cstop offset='1' stop-color='white'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");

  backdrop-filter: blur(15.9px);
  -webkit-backdrop-filter: blur(15.9px);

  @media (max-width: 768px) {
    bottom: 15%;
    height: 50%;
  }
  @media (max-width: 480px) {
    display: none;
  }
`;
const MobileBlurLayer = styled.div`
  display: none;

  @media (max-width: 480px) {
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    right: 0;
    bottom: 10%;
    height: 70%;
    z-index: 2;
    pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='440' height='445' viewBox='0 0 440 445' fill='none'%3E%3CforeignObject x='-39.2148' y='-7' width='518.43' height='458.498'%3E%3Cdiv xmlns='http://www.w3.org/1999/xhtml' style='backdrop-filter:blur(3.5px);clip-path:url(%23bgblur_0_98_153_clip_path);height:100%25;width:100%25'%3E%3C/div%3E%3C/foreignObject%3E%3Cg filter='url(%23filter0_n_98_153)' data-figma-bg-blur-radius='7'%3E%3Crect x='-32.2148' width='504.43' height='444.498' fill='url(%23paint0_linear_98_153)' fill-opacity='0.5'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_n_98_153' x='-39.2148' y='-7' width='518.43' height='458.498' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2 2' stitchTiles='stitch' numOctaves='3' result='noise' seed='5857'/%3E%3CfeColorMatrix in='noise' type='luminanceToAlpha' result='alphaNoise'/%3E%3CfeComponentTransfer in='alphaNoise' result='coloredNoise1'%3E%3CfeFuncA type='discrete' tableValues='1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 '/%3E%3C/feComponentTransfer%3E%3CfeComposite operator='in' in2='shape' in='coloredNoise1' result='noise1Clipped'/%3E%3CfeFlood flood-color='rgba(255%2C 255%2C 255%2C 0.25)' result='color1Flood'/%3E%3CfeComposite operator='in' in2='noise1Clipped' in='color1Flood' result='color1'/%3E%3CfeMerge result='effect1_noise_98_153'%3E%3CfeMergeNode in='shape'/%3E%3CfeMergeNode in='color1'/%3E%3C/feMerge%3E%3C/filter%3E%3CclipPath id='bgblur_0_98_153_clip_path' transform='translate(39.2148 7)'%3E%3Crect x='-32.2148' width='504.43' height='444.498'/%3E%3C/clipPath%3E%3ClinearGradient id='paint0_linear_98_153' x1='220' y1='0' x2='220' y2='444.498' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D9D8D8'/%3E%3Cstop offset='1' stop-color='white'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
    /* background-size: 100% 100%; */
    /* background-repeat: no-repeat; */
    backdrop-filter: blur(3.5px);
    -webkit-backdrop-filter: blur(3.5px);
  }
`;
const BrowserImage = styled.img`
  width: 100%;
  display: block;
  user-select: none;
`;

const BrowserPreview = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0px;
  width: 100%;
  max-width: 1100px;
  transform: translateX(-50%);
  z-index: 4;
  filter: drop-shadow(0 22px 32px rgba(0, 0, 0, 0.16));

  @media (max-width: 1600px) {
    width: 100%;
    bottom: -40px;
  }
  @media (max-width: 1024px) {
    width: 100%;
    bottom: -120px;
  }
  @media (max-width: 768px) {
    width: 100%;
    bottom: 0;
  }
  @media (max-width: 600px) {
display: none;
  }
`;

const AgentPanel = styled.div`
  position: absolute;
  left: 50%;
  top: 18%;
  width: min(440px, 48%);
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #050505;
  text-align: center;
`;

const AgentImage = styled.img`
  width: clamp(82px, 10vw, 152px);
  height: clamp(82px, 10vw, 152px);
  object-fit: contain;
  margin-bottom: clamp(10px, 1.2vw, 16px);
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.2));
  animation: agentArrive 0.85s cubic-bezier(0.2, 0.9, 0.2, 1.15) both,
    agentFloat 3.2s ease-in-out 0.9s infinite;

  @keyframes agentArrive {
    0% {
      opacity: 0;
      transform: translateY(24px) scale(0.72) rotate(-10deg);
      filter: blur(6px) drop-shadow(0 14px 18px rgba(0, 0, 0, 0.2));
    }

    70% {
      opacity: 1;
      transform: translateY(-5px) scale(1.06) rotate(3deg);
      filter: blur(0) drop-shadow(0 18px 22px rgba(0, 0, 0, 0.24));
    }

    100% {
      opacity: 1;
      transform: translateY(0) scale(1) rotate(0deg);
      filter: blur(0) drop-shadow(0 14px 18px rgba(0, 0, 0, 0.2));
    }
  }

  @keyframes agentFloat {
    0%,
    100% {
      transform: translateY(0) rotate(0deg);
    }

    50% {
      transform: translateY(-8px) rotate(2deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Greeting = styled.p`
  margin: 13px 0 10px 4px;
  font-size: clamp(10px, 0.92vw, 14px);
  line-height: 1.2;
  min-height: clamp(12px, 1.1vw, 17px);
`;

const AgentTitle = styled.h1`
  margin: 0 0 clamp(12px, 1.4vw, 18px);
  font-size: clamp(24px, 2.7vw, 42px);
  line-height: 1.05;
  font-family: "primary1" !important;
  font-weight: 700;
  letter-spacing: 0;
  /* min-height: clamp(50px, 5.8vw, 88px); */
`;

const TypingCursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 0.82em;
  margin-left: 3px;
  border-radius: 999px;
  background: currentColor;
  transform: translateY(0.08em);
  animation: cursorBlink 0.75s steps(2, start) infinite;

  @keyframes cursorBlink {
    0%,
    45% {
      opacity: 1;
    }

    46%,
    100% {
      opacity: 0;
    }
  }
`;

const SearchForm = styled.form`
  width: min(420px, 100%);
  height: 42px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 5px 5px 14px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.16);
  border: 1px solid rgba(0, 0, 0, 0.06);
  cursor: text;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #111;
  font-size: 12px;

  &::placeholder {
    color: #7c7c7c;
    opacity: 1;
  }
`;

const SearchButton = styled.button`
  width: 31px;
  height: 31px;
  flex: 0 0 31px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #050505;
  color: #fff;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 14px rgba(0, 0, 0, 0.22);
  }
`;

const ModalShell = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: min(460px, calc(100vw - 34px));
  transform: translate(-50%, -50%);
  border-radius: 8px;
  padding: 34px 28px 30px;
  overflow: hidden;
  color: #050505;
  text-align: center;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.84), rgba(255, 255, 255, 0.58)),
    radial-gradient(circle at 50% 0%, rgba(185, 222, 255, 0.52), transparent 54%);
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 0 28px 80px rgba(22, 41, 61, 0.28);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
`;

const ModalClose = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  color: #111;
  cursor: pointer;

  svg {
    width: 17px;
    height: 17px;
  }
`;

const ModalAgentImage = styled.img`
  width: 104px;
  height: 104px;
  object-fit: contain;
  margin-bottom: 16px;
  filter: drop-shadow(0 16px 22px rgba(0, 0, 0, 0.22));
`;

const ModalTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 1.12;
  font-family: "primary1" !important;
`;

const ModalText = styled.p`
  margin: 0 0 22px;
  color: #333;
  font-size: 14px;
  line-height: 1.45;
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 22px;
  border-radius: 999px;
  background: #050505;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
`;
const BrowserImageMobile = styled.img`
  position: absolute;
  left: 50%;
  top: 16%;
  width: 85%;
  max-width: 320px;
  height: auto;          /* fix: was height: 100% causing stretch */
  object-fit: contain;
  transform: translateX(-50%);
  z-index: 4;
  filter: drop-shadow(0 22px 32px rgba(0, 0, 0, 0.16));
  user-select: none;

  @media (min-width: 601px) {
    display: none;
  }
`;

const CloudImage = styled.img`
  position: absolute;
  left: 50%;
  bottom: -100px;
  width: max(1180px, 100vw);
  max-width: none;
  transform: translate3d(calc(-50% + var(--cloud-x)), var(--cloud-y), 0);
  z-index: 5;
  user-select: none;
  pointer-events: none;
  will-change: transform;

  @media (max-width: 1600px) {
    bottom: -100px;
    width: max(900px, 110vw);
  }
  @media (max-width: 1024px) {
    bottom: -120px;
  }
  @media (max-width: 768px) {
    bottom: 0;
    width: max(700px, 130vw);
  }
  @media (max-width: 600px) {
display: none;
  }

`;
const CloudImageMobile = styled.img`
  position: absolute;
  left: 50%;
  bottom: -110px;
  width: 100%;
  max-width: 450px;
  transform: translate3d(calc(-50% + var(--cloud-x)), var(--cloud-y), 0);
  z-index: 5;
  user-select: none;
  pointer-events: none;
  will-change: transform;

  @media (min-width: 601px) {
  display: none;
  }

`;

const Header = () => {
  const wrapperRef = useRef(null);
  const frameRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [typedPlaceholder, setTypedPlaceholder] = useState("");
  const [typedGreeting, setTypedGreeting] = useState("");
  const [typedTitle, setTypedTitle] = useState("");
  const [isIntroTyping, setIsIntroTyping] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const motionRef = useRef({
    mouseX: 0,
    mouseY: 0,
    targetMouseX: 0,
    targetMouseY: 0,
    scrollY: 0,
    scrollHeight: 0,
  });

  useEffect(() => {
    const greetingText = "Welcome to Zephyr";
    const titleText = "How can I help you?";
    const timers = [];

    [...greetingText].forEach((_, index) => {
      timers.push(
        setTimeout(() => {
          setTypedGreeting(greetingText.slice(0, index + 1));
        }, 560 + index * 42)
      );
    });

    const titleStartDelay = 560 + greetingText.length * 42 + 180;

    [...titleText].forEach((_, index) => {
      timers.push(
        setTimeout(() => {
          setTypedTitle(titleText.slice(0, index + 1));
        }, titleStartDelay + index * 48)
      );
    });

    timers.push(
      setTimeout(() => {
        setIsIntroTyping(false);
      }, titleStartDelay + titleText.length * 48 + 250)
    );

    return () => {
      timers.forEach(clearTimeout);
    };
  }, []);

  useEffect(() => {
    const text = "Search now";
    let index = 0;
    let timeoutId;

    const typePlaceholder = () => {
      setTypedPlaceholder(text.slice(0, index));
      index += 1;

      if (index <= text.length) {
        timeoutId = setTimeout(typePlaceholder, 95);
        return;
      }

      timeoutId = setTimeout(() => {
        index = 0;
        typePlaceholder();
      }, 1800);
    };

    typePlaceholder();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const wrapper = wrapperRef.current;

    if (!wrapper || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      wrapper.style.setProperty("--zephyr-rotate-x", "0deg");
      wrapper.style.setProperty("--zephyr-rotate-y", "0deg");
      wrapper.style.setProperty("--cloud-y", "0px");
      return undefined;
    }

    if (window.matchMedia("(max-width: 768px)").matches) {
      wrapper.style.setProperty("--zephyr-x", "0px");
      wrapper.style.setProperty("--zephyr-y", "0px");
      wrapper.style.setProperty("--zephyr-rotate-x", "0deg");
      wrapper.style.setProperty("--zephyr-rotate-y", "0deg");
      wrapper.style.setProperty("--cloud-x", "0px");
      wrapper.style.setProperty("--cloud-y", "0px");
      return undefined;
    }

    const lerp = (a, b, t) => a + (b - a) * t;

    const updateParallax = () => {
      const motion = motionRef.current;

      // Smooth mouse inertia
      motion.mouseX = lerp(motion.mouseX, motion.targetMouseX, 0.04);
      motion.mouseY = lerp(motion.mouseY, motion.targetMouseY, 0.04);

      const { mouseX, mouseY, scrollY, scrollHeight } = motion;

      // Zephyr translate — subtle drift with cursor
      const zephyrX = mouseX * 22;
      const zephyrY = mouseY * 16 + scrollY * -0.02;

      // Tilt TOWARD cursor:
      // cursor right (+mouseX) → rotateY positive → right side tilts toward viewer
      // cursor down (+mouseY) → rotateX positive → bottom tilts toward viewer
      const zephyrRotateY = mouseX * 10;   // tilt left/right toward cursor
      const zephyrRotateX = mouseY * 8;    // tilt up/down toward cursor

      // Cloud scroll-in
      const scrollProgress = scrollHeight
        ? Math.min(1, scrollY / (scrollHeight * 0.85))
        : 1;
      const eased = 1 - Math.pow(1 - scrollProgress, 5);
      const cloudScrollOffset = (1 - eased) * 280;
      const mouseInfluence = eased;
      const cloudX = mouseX * -42 * mouseInfluence;
      const cloudY = mouseY * -16 * mouseInfluence + cloudScrollOffset + scrollY * -0.02;

      wrapper.style.setProperty("--zephyr-x", `${zephyrX}px`);
      wrapper.style.setProperty("--zephyr-y", `${zephyrY}px`);
      wrapper.style.setProperty("--zephyr-rotate-x", `${zephyrRotateX}deg`);
      wrapper.style.setProperty("--zephyr-rotate-y", `${zephyrRotateY}deg`);
      wrapper.style.setProperty("--cloud-x", `${cloudX}px`);
      wrapper.style.setProperty("--cloud-y", `${cloudY}px`);

      frameRef.current = requestAnimationFrame(updateParallax);
    };

    frameRef.current = requestAnimationFrame(updateParallax);

    const handleMouseMove = (event) => {
      const rect = wrapper.getBoundingClientRect();
      motionRef.current.targetMouseX = (event.clientX - rect.left) / rect.width - 0.5;
      motionRef.current.targetMouseY = (event.clientY - rect.top) / rect.height - 0.5;
    };

    const handleMouseLeave = () => {
      motionRef.current.targetMouseX = 0;
      motionRef.current.targetMouseY = 0;
    };

    const handleScroll = () => {
      const rect = wrapper.getBoundingClientRect();
      motionRef.current.scrollY = Math.min(Math.max(-rect.top, 0), rect.height);
      motionRef.current.scrollHeight = rect.height;
    };

    wrapper.addEventListener("mousemove", handleMouseMove);
    wrapper.addEventListener("mouseleave", handleMouseLeave);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      wrapper.removeEventListener("mousemove", handleMouseMove);
      wrapper.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("scroll", handleScroll);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, []);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <Wrapper ref={wrapperRef}>
      <ZephyrImage src={zephyr} alt="Zephyr" />
      <BlurLayer />
         <MobileBlurLayer /> 
      <BrowserPreview>
        <BrowserImage src={browsersimple} alt="Zephyr browser preview" />
        <AgentPanel>
          <AgentImage src={aiagent} alt="Zephyr AI Agent" />
          <Greeting>
            {typedGreeting}
            {isIntroTyping && !typedTitle && <TypingCursor />}
          </Greeting>
          <AgentTitle>
            {typedTitle}
            {isIntroTyping && typedTitle && <TypingCursor />}
          </AgentTitle>
          <SearchForm onSubmit={handleSearchSubmit}>
            <SearchInput
              aria-label="Search with Zephyr AI Agent"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              placeholder={typedPlaceholder || "Search now"}
            />
            <SearchButton type="submit" aria-label="Open Zephyr AI Agent">
              <ArrowForwardIcon />
            </SearchButton>
          </SearchForm>
        </AgentPanel>
      </BrowserPreview>
      <BrowserImageMobile src={mobilebrowser} alt="Zephyr browser preview" />
      <CloudImage src={cloudimg} alt="" aria-hidden="true" />
      <CloudImageMobile src={mobilecloud} alt="" aria-hidden="true" />
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="zephyr-agent-download-title"
      >
        <ModalShell>
          <ModalClose type="button" onClick={() => setIsModalOpen(false)} aria-label="Close">
            <CloseIcon />
          </ModalClose>
          <ModalAgentImage src={aiagent} alt="" aria-hidden="true" />
          <ModalTitle id="zephyr-agent-download-title">Download the Zephyr Net</ModalTitle>
          <ModalText>
            Download Zephyr to start chatting privately.
          </ModalText>
          <DownloadButton href="https://zephyrbrowser.com/browser/zephyr-1.0.0.exe">Download Now</DownloadButton>
        </ModalShell>
      </Modal>
    </Wrapper>
  );
};

export default Header;
